import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/search.svg'
import _imports_1 from '@/assets/icon/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-dfb281e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component popup" }
const _hoisted_2 = { class: "popup_box contents__box" }
const _hoisted_3 = { class: "top_box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Dicom Tag")
], -1))
const _hoisted_5 = { class: "tag_search_box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = { class: "table_wrap" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"table_header\" data-v-dfb281e0><div style=\"width:15%;\" data-v-dfb281e0>(Group, Element)</div><div style=\"width:30%;\" data-v-dfb281e0>TAG Description</div><div style=\"width:5%;\" data-v-dfb281e0>VR</div><div style=\"width:5%;\" data-v-dfb281e0>VM</div><div style=\"width:45%;\" data-v-dfb281e0>Value</div></div>", 1)
const _hoisted_9 = { style: {"width":"15%"} }
const _hoisted_10 = { style: {"width":"30%"} }
const _hoisted_11 = { style: {"width":"5%","text-align":"center"} }
const _hoisted_12 = { style: {"width":"5%","text-align":"center"} }
const _hoisted_13 = {
  style: {"max-width":"45%"},
  class: "tag-value"
}
const _hoisted_14 = ["onMouseenter", "onMouseleave"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
              placeholder: "Search",
              onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchDicomTag()))
            }, null, 544), [
              [_vModelText, _ctx.searchText]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", {
            class: _normalizeClass(["table_body_wrap my-scroll", {scroll_active: _ctx.searchRes?.length>17}])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchRes, (tag) => {
              return (_openBlock(), _createElementBlock("div", {
                key: tag,
                class: "dicom_tag_data table_body"
              }, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(tag.tag), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(tag.description), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(tag.vr), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(tag.vm), 1),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h3", {
                    class: "text-ellipsis",
                    onMouseenter: ($event: any) => (_ctx.handleMouseEnter($event, tag)),
                    onMouseleave: ($event: any) => (_ctx.handleMouseLeave(tag))
                  }, _toDisplayString(tag.value), 41, _hoisted_14)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass([{show: tag.showTooltip}, "tooltip"])
                }, [
                  _createElementVNode("h3", null, _toDisplayString(tag.value), 1)
                ], 2)
              ]))
            }), 128))
          ], 2)
        ])
      ]),
      _createElementVNode("img", {
        src: _imports_1,
        class: "close_icon",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleConfirmClick()))
      })
    ])
  ]))
}